import React from "react";
import Marquee from "react-fast-marquee";

const items = [
  "Searchable Authority",
  "High-Intent Viewers",
  "Evergreen Organic Traffic",
  "Lead Generation",
  "Content Clusters",
  "Customer Psychology",
  "Trust Building",
  "Conversion Systems",
];

export default function EditorialMarquee() {
  return (
    <div className="bg-brand-black py-6 sm:py-8 border-y-2 border-brand-black overflow-hidden" data-testid="marquee">
      <Marquee speed={40} gradient={false} autoFill>
        {items.map((t, i) => (
          <span key={i} className="mx-6 sm:mx-10 flex items-center gap-6 sm:gap-10">
            <span className={`font-display text-3xl sm:text-5xl md:text-6xl uppercase tracking-tight ${i % 2 === 0 ? "text-brand-cream" : "stroke-text"}`}>
              {t}
            </span>
            <span className="h-3 w-3 rounded-full bg-brand-red shrink-0" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
